// extracted by mini-css-extract-plugin
export default {"text":"mimic___styles_text__6lCJA","mail":"mimic___styles_mail__Z3lQI"};